<template>
  <div class="col-7 d-flex flex-column justify-center posr mb-9">
    <div class="search-input_block d-flex posr px-0">
      <input
        class="search-global form-control standart-input input"
        type="text"
        id="searchModels"
        v-model="searchGlobal"
        ref="inputSearch"
        @keydown.down.prevent="highlightedNext"
        @keydown.up.prevent="highlightedPrev"
        @keydown.enter.prevent="enterListItem()"
        @keydown.escape.prevent="toggleSearchList"
        @blur="close = true"
        @focus="openSearchList"
        :placeholder="placeholder"
        :class="{'search--border': searchGlobal !== ''}"
      />
      <!-- @keydown.exact="resetPositionSelect($event)" -->
      <div class="search_btn">
        <i @click="enterListItem()" class="icon-arrow-right active-color fz20"></i>
      </div>

      <transition name="slideup-fade" mode="out-in">
        <transition-group
          v-show="!close"
          name="slide-fade"
          tag="ul"
          class="search-list w-100 px-0 bdrs5"
          id="list_block"
          ref="searchModelList"
        >
          <!-- <li key="search_typed" ref="srch" class="list_item">
          <a :href="'/models?name='+searchGlobal">
            <i class="icon-search icon_search"></i>
            {{searchGlobal}}
          </a>
          </li>-->
          <li
            v-for="(className, i) of filteredDataClass"
            :key="className.code"
            class="list_item"
            :class="{'active-list_item': i === highlightedIndex}"
            ref="findCategory"
          >
            <a :href="'/models?name='+searchGlobal"  v-if="i === 0">
              <!-- <a href=""  @click="enterListItem(i)" v-if="i === 0"> -->
              <i class="icon-search icon_search"></i>
              {{searchGlobal}}
            </a>

            <a v-else :href="'/models/view/card/sort/new/limit/20/code_class/'+className.code">
              <!-- <a v-else @click="enterListItem(i)" href=""> -->
              <i class="icon-grid icon_search"></i>
              {{className.name}}
              <span class="category-search">Модели</span>
            </a>
          </li>
        </transition-group>
      </transition>
    </div>

    <!-- <div class="w-100 mb-6"></div> -->

    <!-- <div class="under_search d-flex justify-space-between col-7 px-0"> -->
    <!-- <div> -->
    <!-- <span class="fz12 op05">Например:</span> -->
    <!-- <span class="op1 cp" @click="searchRandomWords">{{ randomResult }}</span> -->
    <!-- </div> -->

    <!-- <button class="fz13" @mouseenter="monkey = false" @mouseleave="monkey = true" @click="searchImLucky"> -->
    <!-- <span v-if="monkey">🙉</span> -->
    <!-- <span v-else>🙈</span> Мне повезёт -->
    <!-- </button> -->
    <!-- </div> -->
  </div>
</template>

<script>
/*
При открытии окна счётчик равен 0, когда появляется список счётчик равен 0 (counter = 0)
при нажатии на ESC и открытом списке счётчик становится 1 и список закрывается. Через 10 сек. снова становится равен 0.
При нажатии на ESC если список закрыт окно закрывается (counter = 0)
*/
export default {
  props: {
    placeholder: {
      type: String,
      default: "Поиск"
    }
  },
  data() {
    return {
      monkey: true,
      loading: false,
      showModal: "close",
      searchGlobal: "",
      getClass: [],
      getOrganization: [],
      getOrganizationFull: [],
      selectedEl: null,
      close: true,
      filteredArray: [],
      activeTab: 1,
      modelList: [],
      totalmodels: 0,
      highlightedIndex: 0,
      randomArrSearch: [
        "Окно трехстворчатое",
        "Дверь внутренняя",
        "Перегородки ГКЛ",
        "Турникет",
        "Стена кирпичная",
        "Клапан балансировочный",
        "Задвижка ножевая",
        "Кран шаровой",
        "Светильник уличный",
        "Скамья из бетона"
      ],
      randomResult: ''
    };
  },
  created () {
    this.getData();
    this.getUrlParams();
    this.numberWithSpaces();
    this.showRandomWords();
  },
  mounted() {
    if (this.searchGlobal) {
      this.$store.dispatch("searchText", this.searchGlobal);
    }
  },
  watch: {
    searchGlobal() {
      if (this.searchGlobal.length >= 2 && !_.isEmpty(this.filteredDataClass)) {
        this.close = false;
      } else return (this.close = true);
    },
    filteredArray: "pushFilteredDataInArray"
  },
  computed: {
    /**
     * Фильтруем массив class
     */
    filteredDataClass() {
      let searchDataClass = this.getClass.filter(post => {
        return (
          post.name.toLowerCase().includes(this.searchGlobal.toLowerCase()) ||
          post.meta_alias
            .toLowerCase()
            .includes(this.searchGlobal.toLowerCase())
        );
      });
      return searchDataClass;
    }
  },

  methods: {
    checkRandomWords() {
      let rand = Math.floor(Math.random() * this.randomArrSearch.length);
      return rand
    },
    showRandomWords() {
      let rand = this.checkRandomWords();
      this.randomResult = this.randomArrSearch[rand]
    },
    searchRandomWords() {
      this.searchGlobal = this.randomResult
      this.$nextTick(() => {
        this.enterListItem()
      })
    },
    searchImLucky() {
      let rand = this.checkRandomWords();
      this.searchGlobal = this.randomArrSearch[rand]
      this.$nextTick(() => {
        this.enterListItem()
      })
    },
    scrollToHighligted() {
      this.$refs.searchModelList.children[
        this.highlightedIndex
        ].elm.scrollIntoView({
        block: "nearest"
      });
    },
    highlight(index) {
      this.highlightedIndex = index;

      if (this.highlightedIndex < 0) {
        this.highlightedIndex = this.filteredDataClass.length - 1;
      }
      if (this.highlightedIndex > this.filteredDataClass.length - 1) {
        this.highlightedIndex = 0;
      }
      this.scrollToHighligted();
    },

    highlightedPrev() {
      this.highlight(this.highlightedIndex - 1);
    },
    highlightedNext() {
      this.highlight(this.highlightedIndex + 1);
    },
    scrollingToTop() {
      this.$refs.search_wrapper.scrollIntoView({
        top: 0,
        behavior: "smooth"
      });
    },
    /**
     * Ф-ия разделения чисел на разряды
     */
    numberWithSpaces(x) {
      return _.toString(x).replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    openSearchList() {
      if (this.searchGlobal.length >= 2 && !_.isEmpty(this.filteredDataClass)) {
        this.close = false;
      } else this.close = true;
    },
    /**
     * Получение параметров из GET и добавление в INPUT
     */
    getUrlParams() {
      let url_params = new URLSearchParams();
      if (window.location.toString().indexOf("?") != -1) {
        let href_part = window.location.search.split("?")[1];
        href_part.replace(/([^=&]+)=([^&]*)/g, function(m, key, value) {
          let attr = decodeURIComponent(key);
          let val = decodeURIComponent(value);
          url_params.append(attr, val);
        });
      }
      for (let pair of url_params.entries()) {
        // console.log(pair[0]+ '->'+ pair[1]);
        if (pair[1] != []) {
          this.searchGlobal = pair[1];
        }
      }
      // console.log(url_params);
      return url_params;
    },
    /**
     * Открытие и закрытие списка результатов (ESC)
     */
    toggleSearchList() {
      this.close = true;
      this.selectedEl = null;
      this.perebor();
    },
    /**
     * Получаем массивы данных из JSON
     */
    getDataParams(id) {
      // this.getDataModels(id);
    },
    getDataModels(val) {
      let man = false;
      if (val === "add_30_models") {
        this.loading = true;
        if (this.page_models === this.totalpages) {
          this.modelList = [];
        } else {
          this.page_models = this.page_models + 1;
        }
      } else {
        if (!_.isEmpty(val)) {
          data.append("manufacturer", val);
          man = true;
        }
      }

      const data = new URLSearchParams();
      // if (this.limit) {
      //     data.append('limit', this.limit);
      data.append("limit", 30);
      // }
      if (this.page_models) {
        data.append("page", this.page_models);
      }
      // if (this.sort) {
      //     data.append('sort', this.sort);
      // }
      // if (!_.isEmpty(this.searchGlobal) && !man) {
      if (!man) {
        //     this.setUrlState('models', 'Models search', '/models?name=' + this.searchfield);
        //     this.currentUrl = '/models?name=' + this.searchfield;
        data.append("name", this.searchGlobal);
      }
      axios
        .post("/?m=BimModelsList&a=getModelsJson", data)
        .then(response => {
          this.loading = false;
          // console.log(response);
          // console.log(response.data.Result.Grid.totalItems);
          // console.log(response.data.Result.Grid.data+' _response');
          if (response.data.Result.Grid.totalItems !== 0) {
            //кол-во моделей
            this.totalmodels = response.data.Result.Grid.totalItems;
          } else {
            this.totalmodels = 0;
          }
          if (response.data.Result.Grid.totalPages !== 0) {
            if (response.data.Result.Grid.totalPages == 2) {
              //кол-во страниц
              this.totalmodelsPages = response.data.Result.Grid.totalPages;
            } else {
              this.totalmodelsPages = response.data.Result.Grid.totalPages;
            }
            if (this.totalmodelsPages < this.page) {
              this.changePage(this.totalmodelsPages);
              return;
            }
          } else {
            this.totalmodelsPages = 0;
          }
          if (!_.isEmpty(response.data.Result.Grid.data)) {
            if (val !== "add_30_models") {
              this.modelList = [];
            }

            this.modelList.push(...response.data.Result.Grid.data)
          } else {
            this.modelList = [];
            // this.resultnull = true;
          }
        })
        .catch(function(error) {
          console.log(error);
        });
    },
    getData() {
      axios
        .get("/?a=GetCatLists&key=ext")
        .then(response => {
          // console.log(response.data.class, 'Class');
          this.getClass.push(...response.data.class);
        })
        .catch(function(error) {
          console.log(error);
        });
    },

    /**
     * Переход по списку при помощи стрелок
     */
    // selectListItemDown() {
    //   if (
    //     this.searchGlobal.length >= 2 &&
    //     (this.filteredDataClass != "" || this.filteredDataOrg != "") &&
    //     this.selectedEl != this.$refs.findCategory.length
    //   ) {
    //     this.selectedEl++;
    //     this.perebor();
    //   }
    // },
    // selectListItemUp() {
    //   if (
    //     this.searchGlobal.length >= 2 &&
    //     (this.filteredDataClass != "" || this.filteredDataOrg != "") &&
    //     this.selectedEl != 0
    //   ) {
    //     this.selectedEl--;
    //     this.perebor();
    //   }
    // },
    // perebor() {
    //   let item = _.concat(this.$refs.srch, this.$refs.findCategory);

    //   for (let i = 0; i < item.length; i++) {
    //     if (i == this.selectedEl) {
    //       item[i].classList.add("active-list_item");
    //       if (i + 1 < item.length) {
    //         item[i].scrollIntoView({ block: "nearest" });
    //       }
    //     } else {
    //       item[i].classList.remove("active-list_item");
    //     }
    //   }
    // },

    /**
     * Отображение результатов
     */
    enterListItem(idx) {
      // if (enterPress) {
      if (idx === 0) this.highlightedIndex = 0;

      let item = _.concat(this.$refs.findCategory, this.$refs.srch);
      item.forEach((item, index) => {
        if (index == this.highlightedIndex && this.highlightedIndex !== 0) {
          // this.searchGlobal = this.filteredDataClass[index].name;
          // window.open(item.firstChild.getAttribute("href"));
          location.href = item.firstChild.getAttribute("href");

        }
      });
      this.getDataParams();
      // }
      // let item = _.concat(this.$refs.findCategory, this.$refs.srch);
      this.$store.dispatch("searchText", this.searchGlobal);
      this.close = true;
    },
    getCompanyData(id) {
      this.getDataParams(id);
      // let item = _.concat(this.$refs.findCategory, this.$refs.srch);
      this.close = true;
    },

    /**
     * Сброс позиции выбора при вводе новых параметров поиска
     */
    // resetPositionSelect(e) {
    //   if (
    //     e.keyCode != 38 &&
    //     e.keyCode != 40 &&
    //     e.keyCode != 13 &&
    //     this.searchGlobal.length >= 2
    //   ) {
    //     this.close = true;
    //     this.selectedEl = 0;
    //     this.perebor();
    //   }
    // },
    sliceText(value, symbol) {
      return _.truncate(value, { length: symbol, separator: "..." });
    }
  }
};
</script>

<style lang="scss" scoped>
@import './src/front_white/sass/components/color';
@import './src/front_white/sass/components/mixins';

.under_search{
  @include font-main(12px, normal, 1.75, 0.2px, $text-super-light);
}
.search-tab_link {
  cursor: pointer;

  @include font-main(18px, bold, 1.33, normal, $text-search);

  &:hover {
    color: $text-second-dark;
  }
}
.search-tab_link--active {
  color: $active !important;
}
.search-wrapper {
  position: relative;

  padding-top: 5rem;
  // overflow: hidden;
}

.icon_search {
  padding-right: 2.1333rem;

  color: $text-soft-dark;
}

.label-list {
  display: inline-flex;
  padding: 0rem 2.1333rem;

  font-weight: bold;
}

.active-list_item {
  background-color: $bg-search;
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  // transform: translateX(0.625rem);
  opacity: 0;
}

.slideup-fade-enter-active {
  transition: all 0.3s ease;
}
.slideup-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}
.slideup-fade-enter,
.slideup-fade-leave-to
  /* .slide-fade-leave-active до версии 2.1.8 */ {
  // transform: translateY(-0.625rem);
  opacity: 0;
}
// Модели
.models {
  max-height: 20.7rem;
  padding-top: 2px;
  overflow: hidden;

  transition: all 0.3s;
}
.show {
  max-height: 100% !important;
}

.activeInf {
  color: $active;

  fill: $active;
  -webkit-text-fill-color: $active;
}
</style>
